import React, { useState, useEffect } from 'react';
import { Download, X } from 'lucide-react';
import { isRunningAsApp } from '../utils/appMode';
import { shouldShowInstallBanner, dismissInstallBanner, showInstallPrompt, isIOS, onInstallAvailableChange } from '../utils/pwaInstall';
import IOSInstallModal from './IOSInstallModal';

const PWAInstallBanner: React.FC = () => {
  const [visible, setVisible] = useState(shouldShowInstallBanner());
  const [showIOSModal, setShowIOSModal] = useState(false);

  useEffect(() => {
    // Subscribe to install availability changes
    const unsubscribe = onInstallAvailableChange(() => {
      setVisible(shouldShowInstallBanner());
    });

    return unsubscribe;
  }, []);

  const handleInstall = async () => {
    // iOS: Show instructions
    if (isIOS()) {
      setShowIOSModal(true);
      return;
    }

    // Chrome/Android: Show native prompt
    const installed = await showInstallPrompt();
    if (installed) {
      setVisible(false);
      dismissInstallBanner();
    }
  };

  const handleDismiss = () => {
    setVisible(false);
    dismissInstallBanner();
  };

  // Don't show if not visible or running as app
  if (!visible || isRunningAsApp()) {
    return null;
  }

  return (
    <>
      {/* iOS Install Modal */}
      <IOSInstallModal
        isOpen={showIOSModal}
        onClose={() => setShowIOSModal(false)}
      />

      {/* Install Banner */}
      <div className="mb-4 bg-gradient-to-r from-pink-500/10 to-cyan-500/10 border border-pink-500/20 rounded-xl p-4">
        <div className="flex items-start justify-between gap-3">
          <div className="flex items-start gap-3 flex-1 min-w-0">
            <div className="flex-shrink-0 w-10 h-10 rounded-full bg-gradient-to-r from-pink-500 to-cyan-500 flex items-center justify-center">
              <Download size={20} className="text-white" />
            </div>
            <div className="flex-1 min-w-0">
              <h3 className="text-white font-semibold text-sm mb-1">Install VybeTribe</h3>
              <p className="text-white/70 text-xs leading-relaxed">
                Faster access, no browser tabs, notifications
              </p>
            </div>
          </div>

          <div className="flex items-center gap-2 flex-shrink-0">
            <button
              onClick={handleInstall}
              className="bg-gradient-to-r from-pink-500 to-cyan-500 hover:from-pink-600 hover:to-cyan-600 text-white px-4 py-2 rounded-full text-xs font-semibold transition-all shadow-lg whitespace-nowrap"
            >
              Get the app
            </button>
            <button
              onClick={handleDismiss}
              className="text-white/60 hover:text-white transition-colors p-1"
              aria-label="Dismiss"
            >
              <X size={18} />
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default PWAInstallBanner;
